import React, { useState, useEffect } from 'react'
import ImageCropper from 'srcReact/components/common2/ImageCropper'
import PureTitle from '../PureTitle'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { mixrActions } from 'srcReact/Mixr/actions'
import styles from './styles.module.scss'
import { commonActions } from 'srcReact/components'
import { createFileFromUrl } from 'srcReact/helpers/fileHelper'

export default function MixrPicture({
  editMode,
  showNextSection,
  hideNextButton,
  openEditMixrPopup,
  setDataToUpdateForRecMixr,
  previewEditMode
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    common: {
      isMobile,
      fileCreation: { files: uploadedFiles, loadingFile, error }
    },
    mixr: {
      editSuccess,
      editLoading,
      mixr,
      mixr: { id, name: mixrName, picture: mixrPicture, recurrence }
    }
  } = useSelector((state) => state)

  const [existingImageUrl, setExistingImageUrl] = useState('')
  const [copyFileTriggered, setCopyFileTriggered] = useState(false)
  const [fileCopied, setFileCopied] = useState(false)
  const [infoForEditReceived, setInfoForEditReceived] = useState(false)
  const [updateTriggered, setUpdateTriggered] = useState(false)
  const [pictureForPreviewUpdated, setPictureForPreviewUpdated] = useState(false)

  useEffect(() => {
    if (!loadingFile && copyFileTriggered && !fileCopied && uploadedFiles?.length > 0) {
      setCopyFileTriggered(false)
      setFileCopied(true)
      dispatch(mixrActions.setMixrData([{ key: 'picture', value: uploadedFiles[0] }]))
    }
  }, [loadingFile, copyFileTriggered, fileCopied, [JSON.stringify(uploadedFiles)]])

  useEffect(() => {
    if ((previewEditMode || editMode) && mixr && mixrPicture) {
      setExistingImageUrl(mixrPicture && mixrPicture.id > 0 ? mixrPicture.url : '')

      //while creating a mixr from existing mixr, if existing mixr has a cover picture, create a new picture_id using fileCreation api for this new mixr.
      // Do not user picture_id of existing mixr- 1206988291134475
      if (mixrPicture?.id > 0 && previewEditMode && !fileCopied) {
        setCopyFileTriggered(true)
        dispatch(
          commonActions.fileCreation(
            [],
            {
              type: 'picture',
              is_logged: 1,
              files_count: 1
            },
            mixrPicture.id
          )
        )
      }
    }
    if (editMode && !infoForEditReceived) {
      setInfoForEditReceived(true)
    }
  }, [mixrPicture, editMode, previewEditMode, fileCopied])

  useEffect(() => {
    if (editSuccess && updateTriggered) {
      //  dispatch(commonActions.fileCreationRemove())
      if (mixrPicture) {
        setExistingImageUrl(mixrPicture.path)
      }
      setUpdateTriggered(false)
    }
  }, [editSuccess])

  const handleSkip = () => {
    showNextSection()
  }
  const handleNext = (picture) => {
    dispatch(mixrActions.setMixrData([{ key: 'picture', value: picture }]))
    showNextSection()
  }
  const handleSave = (picture) => {
    setUpdateTriggered(true)
    const data = {
      picture_id: picture ? picture.id : 0,
      picture_name: picture ? picture.filename : '',
      picture_mime_type: picture ? picture.mimeType : ''
    }
    dispatch(mixrActions.setMixrData([{ key: 'picture', value: picture }]))
    if (previewEditMode) {
      dispatch(mixrActions.setMixrData([{ key: 'picture', value: picture }]))
      setPictureForPreviewUpdated(true)
    } else {
      if (recurrence && recurrence.type !== 'none' && recurrence.is_parent_event !== 1) {
        openEditMixrPopup()
        setDataToUpdateForRecMixr(data)
      } else {
        dispatch(mixrActions.editMixr(id, data))
      }
    }
  }

  return (
    <React.Fragment>
      <PureTitle
        title={t('event.create.basicInfo.mixrPictureTitle')}
        // subTitle={t('event.create.basicInfo.mixrPictureSubTitle')}
        subTitle={
          isMobile
            ? t('group.createGroup.groupPicture.uploadInfoMobile')
            : t('group.createGroup.groupPicture.uploadInfo')
        }
        isRequired={false}
      />

      <ImageCropper
        isMobile={isMobile}
        hideNextButton={hideNextButton}
        editMode={editMode || previewEditMode}
        handleSave={handleSave}
        handleSkip={handleSkip}
        handleNext={handleNext}
        entityUpdated={editSuccess || pictureForPreviewUpdated}
        entityUpdating={editLoading}
        aspectRatio={isMobile ? 10 / 5 : 622 / (622 * 0.34)}
        exisingImageUrl={existingImageUrl}
        text={mixrName}
        showUploadZone={true}
        buttonWrapperSize='medium'
        containerCSS={styles.imageContainer}
      />
    </React.Fragment>
  )
}
